import React, { useEffect } from "react";
import {
  groupByFinancialYear,
  groupByFinancialYearDateWise,
  sumByGroupKey,
} from "../ChartDataHelper";
import CircularGaugeChart from "../../../../CHARTS/CircularGaugeChart";
import { useState } from "react";
import AnimatedDisplay from "../../../../CHARTS/AnimatedDisplay";
import { secondsToHHMM, timeToSeconds2 } from "../../../../Utilitie";
const configKey = {
  No_Of_Demand_By_Engg: 0,
  No_Of_Demand_Agreed_GIVEN: 0,
  Engg_Demand: "00:00:00",
  Agreed_Demand: "00:00:00",
  Granted_Duration: "00:00:00",
  Availed: "00:00:00",
  Corridore: "Corridor",
  Burst: "BURST",
  Granted_Not: "GRANTED",
  Rolling_Block: "Rolling Block",
};
const tableHead = [
  "FY",
  "Demand by Engg",
  "Demand Agreed ",
  "Granted",
  "Availed",
  "Corridor",
  "Burst",
  "Section / Yard",
  "Rolling Block",
];
const SummeryChart = ({ data, dates }) => {
  const [sumData, setSumData] = useState(null);
  const [fyWiseData, setFyWiseData] = useState(null);
  useEffect(() => {
    if (data) {
      const fyData = groupByFinancialYearDateWise(
        data,
        dates.startDate,
        dates.endDate,
      );
      setFyWiseData(fyData);
      // const fyData = groupByFinancialYear(data);
      setSumData(sumByGroupKey(fyData, configKey));
    }
  }, [data]);
  return (
    <div
      className="table-responsive rounded-3 border bg-white shadow-sm p-2"
      style={{
        borderColor: "#d7e2ef",
        boxShadow: "0 4px 16px rgba(6, 59, 135, 0.08)",
      }}
    >
      {/* <table className="table border table-hover papaDiv">
        <thead className="table-dark">
          <tr>
            <th style={{ width: "200px" }} className="text-wrap border">
              <div className="">Fy</div>
            </th>
            {configKey &&
              Object.entries(configKey).map(([thKey], index) => (
                <th key={index}>
                  <div>{thKey.replace("No_Of_", "").replace(/_/g, " ")}</div>
                </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {sumData &&
            Object.entries(sumData).map(([fyKey, rowData], rowIndex) => (
              <tr key={rowIndex}>
                <td className="text-center px-2 py-2" style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}>
                  <div
                    style={{ width: "200px" }}
                    className="text-wrap  d-flex justify-content-center position-relative"
                  >
                    {fyKey}
                    {/* <AnimatedDisplay value={fyKey} fixedWidth="80px" /> */}
      {/* </div>
                </td>
                {configKey &&
                  Object.keys(configKey).map((columnKey, colIndex) => (
                    <td key={colIndex}>
                      <div className="d-flex justify-content-center position-relative">
                        <AnimatedDisplay
                          value={rowData[columnKey]}
                          fixedWidth="60px"
                        />
                      </div>
                    </td>
                  ))}
              </tr>
            ))}
        </tbody>
      </table>  */}
      <table
        className="table table-hover papaDiv table-striped-columns align-middle mb-0"
        style={{
          minWidth: "1050px",
          borderCollapse: "separate",
          borderSpacing: 0,
          fontSize: "12px",
        }}
      >
        <thead className="text-center">
          <tr>
            {tableHead.map((head, i) => (
              <th
                key={i}
                className="text-wrap text-white border-0"
                colSpan={
                  head === "FY" ||
                  head === "Corridor" ||
                  head === "Section / Yard"
                    ? 1
                    : 2
                }
                rowSpan={
                  head === "FY" ||
                  head === "Corridor" ||
                  head === "Section / Yard"
                    ? 2
                    : 1
                }
                style={{
                  background:
                    "linear-gradient(135deg, #870606 0%, #b12b2b 72%, #730808 100%)",
                  color: "#ffffff",
                  verticalAlign: "middle",
                  padding: "10px 8px",
                  whiteSpace: "normal",
                }}
              >
                {head === "Corridor" ? "Corridor (granted)" : head}
              </th>
            ))}
          </tr>

          <tr>
            {tableHead.map((head, i) =>
              head === "FY" ||
              head === "Corridor" ||
              head === "Section / Yard" ? null : (
                <React.Fragment key={i}>
                  <th
                    className="text-white border-0"
                    style={{
                      background: "#9b2a2a",
                      color: "#ffffff",
                      padding: "7px",
                    }}
                  >
                    No
                  </th>
                  <th
                    className="text-white border-0"
                    style={{
                      background: "#e04b4b",
                      color: "#ffffff",
                      padding: "7px",
                    }}
                  >
                    Hr
                  </th>
                </React.Fragment>
              ),
            )}
          </tr>
        </thead>
        <tbody>
          {fyWiseData &&
            Object.entries(fyWiseData).map(([fyKey, rowData], rowIndex) => (
              <tr key={rowIndex}>
                <td
                  className="m-0 px-2 py-2 fw-bold"
                  style={{
                    color: "#063b87",
                    background: "#eef5ff",
                    whiteSpace: "nowrap",
                  }}
                >
                  {fyKey
                    .slice(9, fyKey.length)
                    .replace("(", "")
                    .replace(")", "")}
                </td>
                <td
                  className="text-center px-2 py-2"
                  style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}
                >
                  <div className="d-flex justify-content-center position-relative">
                    <AnimatedDisplay
                      value={rowData.reduce((sum, item) => {
                        return sum + item.No_Of_Demand_By_Engg;
                      }, 0)}
                      fixedWidth="60px"
                    />
                  </div>
                </td>{" "}
                <td
                  className="text-center px-2 py-2"
                  style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}
                >
                  <div className="d-flex justify-content-center position-relative">
                    <AnimatedDisplay
                      value={secondsToHHMM(
                        rowData.reduce((sum, item) => {
                          return sum + timeToSeconds2(item.Engg_Demand);
                        }, 0),
                      )}
                      fixedWidth="60px"
                    />
                  </div>
                </td>{" "}
                <td
                  className="text-center px-2 py-2"
                  style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}
                >
                  {" "}
                  <div className="d-flex justify-content-center position-relative">
                    <AnimatedDisplay
                      value={rowData.reduce((sum, item) => {
                        return sum + item.No_Of_Demand_Agreed_GIVEN;
                      }, 0)}
                      fixedWidth="60px"
                    />
                  </div>
                </td>{" "}
                <td
                  className="text-center px-2 py-2"
                  style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}
                >
                  {" "}
                  <div className="d-flex justify-content-center position-relative">
                    <AnimatedDisplay
                      value={secondsToHHMM(
                        rowData.reduce((sum, item) => {
                          return sum + timeToSeconds2(item.Agreed_Demand);
                        }, 0),
                      )}
                      fixedWidth="60px"
                    />
                  </div>
                </td>
                <td
                  className="text-center px-2 py-2"
                  style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}
                >
                  {" "}
                  <div className="d-flex justify-content-center position-relative">
                    <AnimatedDisplay
                      value={rowData.reduce((sum, item) => {
                        return sum + (item.Granted_Not === "GRANTED" && 1);
                      }, 0)}
                      fixedWidth="60px"
                    />
                  </div>
                </td>
                <td
                  className="text-center px-2 py-2"
                  style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}
                >
                  {" "}
                  <div className="d-flex justify-content-center position-relative">
                    <AnimatedDisplay
                      value={secondsToHHMM(
                        rowData.reduce((sum, item) => {
                          return sum + timeToSeconds2(item.Granted_Duration);
                        }, 0),
                      )}
                      fixedWidth="60px"
                    />
                  </div>
                </td>{" "}
                <td
                  className="text-center px-2 py-2"
                  style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}
                >
                  {" "}
                  <div className="d-flex justify-content-center position-relative">
                    <AnimatedDisplay
                      value={rowData.reduce((sum, item) => {
                        return sum + (item.Availed_Not === "AVAILED" && 1);
                      }, 0)}
                      fixedWidth="60px"
                    />
                  </div>
                </td>
                <td
                  className="text-center px-2 py-2"
                  style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}
                >
                  {" "}
                  <div className="d-flex justify-content-center position-relative">
                    <AnimatedDisplay
                      value={secondsToHHMM(
                        rowData.reduce((sum, item) => {
                          return sum + timeToSeconds2(item.Availed);
                        }, 0),
                      )}
                      fixedWidth="60px"
                    />
                  </div>
                </td>{" "}
                <td
                  className="text-center px-2 py-2"
                  style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}
                >
                  {" "}
                  <div className="d-flex justify-content-center position-relative">
                    <AnimatedDisplay
                      value={rowData.reduce((sum, item) => {
                        return (
                          sum +
                          (item.Availed_Not === "AVAILED" &&
                            item.Granted_Not === "GRANTED" &&
                            1)
                        );
                      }, 0)}
                      fixedWidth="60px"
                    />
                  </div>
                </td>
                <td
                  className="text-center px-2 py-2"
                  style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}
                >
                  {" "}
                  <div className="d-flex justify-content-center position-relative">
                    <AnimatedDisplay
                      value={rowData.reduce((sum, item) => {
                        return (
                          sum +
                          (item.Burst === "BURST" &&
                            item.Granted_Not === "GRANTED" &&
                            1)
                        );
                      }, 0)}
                      fixedWidth="60px"
                    />
                  </div>{" "}
                </td>{" "}
                <td
                  className="text-center px-2 py-2"
                  style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}
                >
                  {" "}
                  <div className="d-flex justify-content-center position-relative">
                    <AnimatedDisplay
                      value={secondsToHHMM(
                        rowData.reduce((sum, item) => {
                          let a = timeToSeconds2(item.Availed);
                          let b = timeToSeconds2(item.Granted_Duration);

                          return (
                            sum +
                            (Number(
                              item.Burst === "BURST"
                                ? a > b
                                  ? a - b
                                  : b - a
                                : 0,
                            ) || 0)
                          );
                        }, 0),
                      )}
                      fixedWidth="60px"
                    />
                  </div>
                </td>{" "}
                <td
                  className="text-center px-2 py-2"
                  style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}
                >
                  {" "}
                  <div className="d-flex justify-content-center position-relative">
                    <AnimatedDisplay
                      value={rowData.reduce((sum, item) => {
                        return sum + (item.Section_Yard === "Yard" && 1);
                      }, 0)}
                      fixedWidth="60px"
                    />{" "}
                    /{" "}
                    <AnimatedDisplay
                      value={rowData.reduce((sum, item) => {
                        return sum + (item.Section_Yard === "Section" && 1);
                      }, 0)}
                      fixedWidth="60px"
                    />
                  </div>
                </td>
                <td
                  className="text-center px-2 py-2"
                  style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}
                >
                  {" "}
                  <div className="d-flex justify-content-center position-relative">
                    <AnimatedDisplay
                      value={rowData.reduce((sum, item) => {
                        return (
                          sum +
                          (item.Availed_Not === "AVAILED" &&
                            item.Rolling_Block === "Rolling Block" &&
                            1)
                        );
                      }, 0)}
                      fixedWidth="60px"
                    />
                  </div>
                </td>
                <td
                  className="text-center px-2 py-2"
                  style={{ borderColor: "#e1eaf5", whiteSpace: "nowrap" }}
                >
                  {" "}
                  <div className="d-flex justify-content-center position-relative">
                    <AnimatedDisplay
                      value={secondsToHHMM(
                        rowData.reduce((sum, item) => {
                          return (
                            sum +
                            timeToSeconds2(
                              item.Availed_Not === "AVAILED" &&
                                item.Rolling_Block === "Rolling Block" &&
                                item.Availed,
                            )
                          );
                        }, 0),
                      )}
                      fixedWidth="60px"
                    />
                  </div>
                </td>{" "}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};
export default SummeryChart;
